import * as React from "react";
import { IconProps } from "./IconProps";

export const IconQuestionSupport = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99935 3.33317C6.31745 3.33317 3.33268 6.31794 3.33268 9.99984C3.33268 13.6817 6.31745 16.6665 9.99935 16.6665C13.6812 16.6665 16.666 13.6817 16.666 9.99984C16.666 6.31794 13.6812 3.33317 9.99935 3.33317ZM1.66602 9.99984C1.66602 5.39746 5.39698 1.6665 9.99935 1.6665C14.6017 1.6665 18.3327 5.39746 18.3327 9.99984C18.3327 14.6022 14.6017 18.3332 9.99935 18.3332C5.39698 18.3332 1.66602 14.6022 1.66602 9.99984ZM10.8831 7.0325C10.3951 6.54447 9.60385 6.54444 9.11506 7.03279C8.87105 7.27657 8.74924 7.59481 8.74935 7.91623C8.7495 8.37647 8.37653 8.74968 7.91629 8.74984C7.45605 8.74999 7.08283 8.37701 7.08268 7.91678C7.08244 7.17149 7.36713 6.42318 7.93708 5.85375C9.07589 4.71597 10.922 4.71434 12.0616 5.85403C13.2007 6.99317 13.2011 8.84054 12.0613 9.97926C11.7011 10.3391 11.2922 10.5982 10.8327 10.7318V12.0832C10.8327 12.5434 10.4596 12.9165 9.99935 12.9165C9.53911 12.9165 9.16601 12.5434 9.16601 12.0832V9.99984C9.16601 9.77229 9.25906 9.55464 9.42356 9.39741C9.58806 9.24019 9.80969 9.15707 10.037 9.16735C10.3372 9.18093 10.5948 9.08849 10.8833 8.80022C11.3712 8.31281 11.3716 7.52109 10.8831 7.0325ZM9.99935 13.3248C10.4596 13.3248 10.8327 13.6979 10.8327 14.1582V14.1665C10.8327 14.6267 10.4596 14.9998 9.99935 14.9998C9.53911 14.9998 9.16601 14.6267 9.16601 14.1665V14.1582C9.16601 13.6979 9.53911 13.3248 9.99935 13.3248Z"
          fill={color}
        />
      </svg>
    );
  },
);
